export default "__VITE_ASSET__NWaa4q6$__"